import React, { useState, useRef, useEffect } from "react"
import { auth } from "../../firebase"
import { sendPasswordResetEmail } from "firebase/auth"
//primereact
import { Image } from "primereact/image"
import { Button } from "primereact/button"
import { Toast } from "primereact/toast"
//components

import Recurso from "../../assets/recurso1.svg"

//navigate
import { useNavigate, useLocation } from "react-router-dom"

import ROUTES from "../../router/routesConstants"
//phoneInput
import "react-phone-number-input/style.css"

import { useUserContext } from "../../context/usercontext"
import axios from "axios"
import GLOBAL from "../../config/variable"
import { ProgressSpinner } from "primereact/progressspinner"

const genderLabels = {
  male: "Masculino",
  female: "Femenino",
  other: "Prefiero no decirlo",
}

function Profile() {
  const location = useLocation()
  const navigate = useNavigate()
  const toast = useRef(null)
  const [userData, setUserData] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const { user, loading } = useUserContext()

  useEffect(() => {
    if (location.state?.updated) {
      const interval = setInterval(() => {
        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Éxito",
            detail: "Perfil actualizado correctamente",
            position: "top-center",
            life: 5000,
          })
          clearInterval(interval)
        }
      }, 100)

      return () => clearInterval(interval)
    }
  }, [location.state])

  useEffect(() => {
    const fetchUser = async () => {
      try {
        setIsLoading(true)
        const response = await axios.get(
          `${GLOBAL.SERVER_URL}/users/${user.uid}`,
          {
            headers: {
              Authorization: `Bearer ${user.accessToken}`,
            },
          }
        )
        setUserData(response.data.data)
      } catch (error) {
        if (error.response && error.response.status === 401) {
          // Redirigir al login si la respuesta es 401
          auth.signOut()
        }
        console.error("Error", error)
      } finally {
        setIsLoading(false)
      }
    }
    if (user?.uid) {
      fetchUser()
    }
  }, [user])

  // Si el contexto está cargando o no hay usuario, mostrar loading
  if (loading || !user) {
    return (
      <div className="container flex align-items-center justify-content-center">
        <ProgressSpinner />
      </div>
    )
  }

  // Si estamos cargando los datos del usuario, mostrar loading
  if (isLoading) {
    return (
      <div className="container flex align-items-center justify-content-center">
        <ProgressSpinner />
      </div>
    )
  }

  const handleResetPassword = async () => {
    try {
      await sendPasswordResetEmail(auth, userData.email)
      // Push successful password reset event to dataLayer
      window.dataLayer.push({
        event: 'password_reset',
        user_id: user.uid,
        user_email: userData.email
      })
      toast.current.show({
        severity: "success",
        summary: "Éxito",
        detail: "Se ha enviado un correo para restablecer tu contraseña",
        position: "top-center",
        life: 5000,
      })
    } catch (error) {
      // Push password reset error event to dataLayer
      window.dataLayer.push({
        event: 'password_reset_error',
        error_message: error.message,
        user_id: user.uid,
        user_email: userData.email
      })
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: error.message,
        position: "top-center",
        life: 5000,
      })
    }
  }

  return (
    <div>
      <Toast ref={toast} position="top-center" life={5000} />

      <div>
        <div className="profile-container mt-2">
          <Image className="mt-5" src={Recurso} alt="logo" width="50" />
          <h2 className="text-2xl font-bold">
            {userData.name_first} {userData.name_last}
          </h2>
          <div className="flex flex-column gap-3">
            <div className="flex justify-content-center">
              <div className="card-points ">
                <p className="text-sm m-0">
                  {userData.points.toLocaleString("en-US")} Pts
                </p>
              </div>
            </div>
            <div className="flex justify-content-start align-items-center gap-2">
              <i className="pi pi-id-card text-sm m-0"></i>
              <p className="text-sm m-0">ID:</p>
              <p className="text-sm m-0">{userData.id_number || "No especificado"}</p>
            </div>
            <div className="flex justify-content-start align-items-center gap-2">
              <i className="pi pi-envelope text-sm m-0"></i>
              <p className="text-sm m-0">{userData.email}</p>
            </div>
            <div className="flex justify-content-start align-items-center gap-2">
              <i className="pi pi-whatsapp text-sm m-0"></i>
              <p className="text-sm m-0">
                {userData.phone_number || "No especificado"}
              </p>
            </div>

            <div className="flex justify-content-start align-items-center gap-2">
              <i className="pi pi-user text-sm m-0"></i>
              <p className="text-sm m-0">Género:</p>
              <p className="text-sm m-0">
                {genderLabels[userData.gender] || "No especificado"}
              </p>
            </div>
            <div className="flex justify-content-start align-items-center gap-2">
              <i className="pi pi-calendar text-sm m-0"></i>
              <p className="text-sm m-0">Cumpleaños:</p>
              <p className="text-sm m-0">
                {userData.birth_date || "No especificado"}
              </p>
            </div>
          </div>
          <div className="flex flex-column">
            <div className="flex flex-column justify-content-between gap-3 my-3 xl:flex-row">
              <Button
                severity="secondary"
                label="Editar Perfil"
                onClick={() => navigate(ROUTES.EDIT_PROFILE)}
              />

              <Button
                severity="info"
                label="Resetear contraseña"
                onClick={handleResetPassword}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Profile
